<template>
    <div class="info">
        <div class="title">
            <h1>【{{ level }}】预约考试地点<span> / 【{{ level }}】Make an appointment for the exam</span></h1>
        </div>
        <div class="tip">可以接受的考试地点（多选，选三个，三个可选城市里，第三个选择必须是北京。必选）</div>
        <el-form :model="enrollInfo" :rules="enrollRules" ref="enrollInfo" label-width="100px" label-position="top" @submit.native.prevent>
            <div class="box">
                <el-form-item label="考试日期选择" prop="aaaa">
					<p v-if="aaaaList.length==0">近期没有考试</p>
                    <el-radio-group v-else v-model="enrollInfo.aaaa" @change="timechange($event,'region1','aaaaid')">
                        <el-radio :label="item.id" :key="item.id" v-for="item in aaaaList">{{ item.examTime | dateTime('yyyy年MM月dd日') }}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="考试地点选择" prop="bbbb">
                    <el-cascader
                        :options="region1"
                        v-model="city"
                        clearable
                        placeholder="请选择考试地点"
                        :props="{
                            'label':'name',
                            'value':'id',
                            'children':'children'
                        }"
                    ></el-cascader>
                </el-form-item>
            </div>
			<div class="box">
			    <el-form-item label="考试日期选择" prop="aaa">
					<p v-if="aaaaList.length==0">近期没有考试</p>
			        <el-radio-group v-else v-model="enrollInfo.aaa"  @change="timechange($event,'region2','aaaid')">
			            <el-radio :label="item.id" :key="item.id" v-for="item in aaaaList">{{ item.examTime | dateTime('yyyy年MM月dd日') }}</el-radio>
			        </el-radio-group>
			    </el-form-item>
			    <el-form-item label="考试地点选择" prop="bbb">
			        <el-cascader
			            :options="region2"
			            v-model="city2"
			            clearable
			            placeholder="请选择考试地点"
			            :props="{
			                'label':'name',
			                'value':'id',
			                'children':'children'
			            }"
			        ></el-cascader>
			    </el-form-item>
			</div>
            <div class="box">
                <el-form-item label="考试日期选择" prop="dddd">
					<p v-if="aaaaList.length==0">近期没有考试</p>
                    <el-radio-group v-else v-model="enrollInfo.dddd" @change="timechange($event,'region3','ddddid')">
                        <el-radio :label="item.id" v-for="item in aaaaList">{{ item.examTime | dateTime('yyyy年MM月dd日') }}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="考试地点选择" prop="eeee">
                    <el-cascader
                        :options="region3"
                        v-model="city1"
                        clearable
						disabled
                        placeholder="请选择考试地点"
                        :props="{
                            'label':'name',
                            'value':'id',
                            'children':'children'
                        }"
                    ></el-cascader>
                    <!-- {{ enrollInfo.eeee }} - {{ enrollInfo.ffff }} -->
                </el-form-item>
            </div>
        </el-form>
        <div class="tip">分配考场时优先选择第一个考场以及时间。7-15个工作日内以短信方式发送至您的手机，请注意查收</div>
        <div class="buttons">
            <el-button :loading="submitLoading" @click="next">提交审核</el-button>
        </div>
    </div>
</template>

<script>
import { EnrollExamAdd,examTimeList,listArea, delayedEnroll, makeUpEnroll } from '@/api/enroll'
import { toTree,addrFilter } from '@/utils'
export default {
    name: 'info',
    components: {
        
    },
    data(){
        return {
            level: '',
            submitLoading: false,
            saveLoading: false,
            aaaaList: [],
            region: [],
			region1: [],
			region2: [],
			region3: [],
            enrollInfo: {
				tbInfoUserId:this.$route.params.id,
				examId:'',
                aaaa:'',
				aaaaid:'',
                bbbb:'',
                cccc:'',
				aaa:'',
				aaaid:'',
				bbb:'',
				ccc:'',
                dddd:'',
				ddddid:'',
                eeee:'',
                ffff:'',
            },
            enrollRules: {
                aaaa: [
                    { required: true, message: '请选择考试日期', trigger: 'change' }
                ],
				aaa: [
				    { required: true, message: '请选择考试日期', trigger: 'change' }
				],
                dddd: [
                    { required: true, message: '请选择考试日期', trigger: 'change' }
                ],
                bbbb: [
                    { required: true, message: '请选择考试地点', trigger: 'change' }
                ],
				bbb: [
				    { required: true, message: '请选择考试地点', trigger: 'change' }
				],
                // eeee: [
                //     { required: true, message: '请选择考试地点', trigger: 'change' }
                // ],
            },
        }
    },
    computed:{
        city:{
            get(){
                return [this.enrollInfo.bbbb, this.enrollInfo.cccc]
            },
            set(val){
                this.enrollInfo.bbbb = val[0]
                this.enrollInfo.cccc = val[1]
            },
        },
        city1:{
            get(){
                return [1, 2]
            },
            set(val){
                this.$set(this.enrollInfo, 'eeee', val[0])
                this.$set(this.enrollInfo, 'ffff', val[1])
            },
        },
		city2:{
		    get(){
		        return [this.enrollInfo.bbb, this.enrollInfo.ccc]
		    },
		    set(val){
		        this.enrollInfo.bbb = val[0]
		        this.enrollInfo.ccc = val[1]
		    },
		},
    },
    mounted(){
        this.$emit('changeIndex',4)
        this.level = this.$route.params.level
		examTimeList({type:this.$filters.testfilters(this.$route.params.level)}).then(res=>{
			if(res){
				this.aaaaList=res
			}
		})
    },
    methods:{
        next(){
            this.$refs['enrollInfo'].validate((valid) => {
                if(valid){
					 let examTime1,examTime2,examTime3
					this.aaaaList.forEach((val,index)=>{
						if(val.id==this.enrollInfo.aaaaid){
							examTime1 = val.examTime
						}
						if(val.id==this.enrollInfo.aaaid){
							examTime2 = val.examTime
						}
						if(val.id==this.enrollInfo.ddddid){
							examTime3 = val.examTime
						}
					})
                    this.submitLoading = true
                    let reqsdata=[
                        {tbInfoUserId:this.$route.params.id,examId:this.enrollInfo.aaaaid,provinceId:this.enrollInfo.bbbb,cityId:this.enrollInfo.cccc,examTime:examTime1},
                        {tbInfoUserId:this.$route.params.id,examId:this.enrollInfo.aaaid,provinceId:this.enrollInfo.bbb,cityId:this.enrollInfo.ccc,examTime:examTime2},
                        {tbInfoUserId:this.$route.params.id,examId:this.enrollInfo.ddddid,provinceId:1,cityId:2,examTime:examTime3},
                    ]
                    if(this.$route.params.type == 1){
                        this.submitLoading = false
                        delayedEnroll({ id: this.$route.params.id, remarks: localStorage.makeupRemark }).then(res => {
                            EnrollExamAdd(reqsdata).then(res => {
                                this.$router.push(`/enroll/audit`)
                            }).catch(res=>{
                                this.submitLoading = true
                            })
                        }).catch(res=>{
                            this.submitLoading = true
                        })
                    }if(this.$route.params.type == 2){
                        this.submitLoading = false
                        makeUpEnroll({ id: this.$route.params.id, type: 2 }).then(res => {
                            reqsdata=[
                                {tbInfoUserId: res.msg, examId:this.enrollInfo.aaaaid,provinceId:this.enrollInfo.bbbb,cityId:this.enrollInfo.cccc},
                                {tbInfoUserId: res.msg, examId:this.enrollInfo.aaaid,provinceId:this.enrollInfo.bbb,cityId:this.enrollInfo.ccc},
                                {tbInfoUserId: res.msg, examId:this.enrollInfo.ddddid,provinceId:1,cityId:2},
                            ]
                            EnrollExamAdd(reqsdata).then(res => {
                                this.$router.push(`/enroll/audit`)
                            }).catch(res=>{
                                this.submitLoading = true
                            })
                        }).catch(res=>{
                            this.submitLoading = true
                        })
                    }else{
                        EnrollExamAdd(reqsdata).then(res => {
                            this.submitLoading = false
                            this.$router.push(`/enroll/audit`)
                        }).catch(res=>{
                            this.submitLoading = true
                        })
                    }
                }
            })
        },
		timechange(v,val,va){
			console.log(val)
			listArea({examId:v}).then(res=>{
				this[val]=toTree(res, 0)
				this.enrollInfo[va]=v
			})
		}
    }
}
</script>

<style scoped>
    @import './info.css';
    .buttons{text-align: center;}
    .box{border:1px solid #e6e6e6;padding: 20px;margin-bottom: 10px;padding-bottom: 8px;}
    .box:last-child{margin-bottom: 4px;}
    .box >>> .el-radio{line-height: 22px;}
    .box >>> .el-form-item{margin-bottom: 20px;}
    .tip{font-size: 14px;color: #666666;line-height: 30px;margin-bottom: 4px;}
</style>
